import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableSortLabel,
  TableBody,
  Typography,
  List,
  ListItem,
  ListItemText,
  Box,
  Grid,
  FormControl,
  InputLabel,
  InputAdornment,
  OutlinedInput,
  Divider,
  Dialog,
  DialogTitle,
  Button,
  Snackbar,
  Alert,
} from "@mui/material";
import React, { useEffect, useState, useContext } from "react";
import { appLogger, Http } from "../../utils";
import { UserContext } from "../../context/userContext";
import { UserLoginInfo } from "../../types/context";
import { getDateTime } from "../../utils/data";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import SearchIcon from "@mui/icons-material/Search";
import { useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import { IconWithToolTip } from "../common";
import DeleteDialog from "../../utils/common/DeleteDialog";
import { ROLE_USER_SUPERADMIN, UserInfo } from "../../model";
import {
  SORT_KEY_EMAIL,
  SORT_KEY_NAME,
  SORT_KEY_MODIFIED_ON,
  SORT_KEY_MODIFIED_BY,
} from "./constants";
import UserForm from "./userForm";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { roleConfig } from "../../utils/config/role-config";
interface TablePaginationActionsProps {
  count: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (
    event: React.MouseEvent<HTMLButtonElement>,
    newPage: number
  ) => void;
}

function TablePaginationActions(props: TablePaginationActionsProps) {
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        <FirstPageIcon />
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        <KeyboardArrowLeft />
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        <KeyboardArrowRight />
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        <LastPageIcon />
      </IconButton>
    </Box>
  );
}

const Manage = (props: any) => {
  const navigate = useNavigate();
  const [initialData, setInitialData] = React.useState([] as UserInfo[]);
  const [users, setUsers] = React.useState([] as UserInfo[]);
  const [searchUsers, setSearchUsers] = React.useState([] as any);
  const { userInfo } = useContext(UserContext) as UserLoginInfo;
  const [orderBy, setOrderBy] = useState(SORT_KEY_MODIFIED_ON);
  const [order, setOrder] = useState<"asc" | "desc">("desc");
  const [itemLimit, setItemLimit] = useState({
    lowerLimit: 0,
    upperLimit: 9,
  });
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [search, setSearch] = React.useState("");
  const [searchKeyword, setSearchKeyword] = React.useState("");
  const [isLoading, setIsloading] = React.useState(false);
  const [alertOpen, setAlertOpen] = React.useState(false);
  const [errorAlertOpen, setErrorAlertOpen] = React.useState(false);
  const [open, setOpen] = useState(false);
  const [deleteTxt, setDeleteTxt] = useState("");
  const [deleteEnable, setDeleteEnable] = useState(false);
  const [deleteID, setDeleteID] = useState([] as any);
  const [openResetPwDialog, setOpenResetPwDialog] = useState(false);
  const [focusEmailId, setFocusEmailId] = useState("");
  const [alertOpenResetPw, setAlertOpenResetPw] = React.useState(false);
  const [errorAlertOpenResetPw, setErrorAlertOpenResetPw] =
    React.useState(false);
  const [editID, setEditID] = useState({} as UserInfo);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [productLists, setProductResponse] = React.useState([] as any);
  const [focusUserId, setFocusUserId] = useState("");

  const hadleEditPopup = () => {
    setEditOpen(false);
  };

  const setDeleteHandle = (e: any) => {
    setDeleteTxt(e.target.value);
    setDeleteEnable(false);

    if (e.target.value.toLowerCase() == "delete") {
      setDeleteEnable(true);
    }
  };

  const clearInput = () => {
    setDeleteTxt("");
    setDeleteEnable(false);
  };

  const handleDeleteOpen = (user: any) => {
    setDeleteTxt("");
    appLogger.info({
      infoObj: {
        method: "handleDeleteOpen",
        component: "users",
        fileName: "manage.tsx",
        deleteUser: user,
      },
    });
    setDeleteID(user);
    setDeleteOpen(true);
  };

  const handleDeleteClose = () => {
    setDeleteOpen(false);
  };

  const hadleEditOpen = (user: UserInfo) => {
    appLogger.info({
      infoObj: {
        method: "hadleEditOpen",
        component: "users",
        fileName: "manage.tsx",
        editUser: user,
      },
    });
    setEditID(user);
    setEditOpen(true);
  };

  useEffect(() => {}, [deleteID]);

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    if (event.target.value === "-1") {
      setItemLimit({
        lowerLimit: 0,
        upperLimit: users.length - 1,
      });
    } else {
      setItemLimit({
        lowerLimit: 0,
        upperLimit: parseInt(event.target.value, 10) - 1,
      });
    }
  };

  const handleRequestSort = (property: string) => {
    if (orderBy === property) {
      setOrder(order === "asc" ? "desc" : "asc");
    } else {
      setOrder("asc");
      setOrderBy(property);
    }
  };

  const fetchUserList = () => {
    if (userInfo && userInfo.idToken && userInfo.idToken.length > 0) {
      setIsloading(true);
      Http.get({
        url: `/api/v2/users/`,
        state: userInfo,
      })
        .then((response: any) => {
          appLogger.info({
            infoObj: {
              method: "fetchUserList",
              component: "users",
              fileName: "manage.tsx",
              userListResponse: response,
            },
          });
          const sortedUsers = sortFunction(response.users);
          setSearchUsers(sortedUsers);
          setIsloading(false);
        })
        .catch((error) => {
          appLogger.error({
            errObj: {
              method: "fetchUserList",
              component: "users",
              fileName: "manage.tsx",
              err: error,
            },
          });
        });
    }
  };

  useEffect(() => {
    fetchUserList();
  }, [userInfo]);

  useEffect(() => {
    setUsers(users);
  }, [alertOpen, errorAlertOpen]);

  const handleAlertClose = () => {
    setAlertOpen(false);
  };

  const handleErrorAlertClose = () => {
    setErrorAlertOpen(false);
  };

  const deleteUser = () => {
    setIsloading(true);
    Http.deleteReq({
      url: `/api/v2/users/${deleteID.id}`,
      state: userInfo,
    })
      .then((response: any) => {
        appLogger.info({
          infoObj: {
            method: "deleteUser",
            component: "users",
            fileName: "manage.tsx",
            deleteUserResponse: response,
          },
        });
        setDeleteOpen(false);
        setIsloading(false);
        setAlertOpen(true);
        setUsers(users.filter((e: any) => e.id != deleteID.id));
      })
      .catch((error) => {
        appLogger.error({
          errObj: {
            method: "deleteUser",
            component: "users",
            fileName: "manage.tsx",
            err: error,
          },
        });
        setIsloading(false);
        setErrorAlertOpen(true);
      });
  };

  function compareEmailId(a: UserInfo, b: UserInfo) {
    return a.emailId.localeCompare(b.emailId);
  }

  function compareEmailIdDesc(a: any, b: any) {
    return b.emailId.localeCompare(a.emailId);
  }

  function compareFirstName(a: UserInfo, b: UserInfo) {
    return a.nameFirst.localeCompare(b.nameFirst);
  }

  function compareFirstNameDesc(a: UserInfo, b: UserInfo) {
    return b.nameFirst.localeCompare(a.nameFirst);
  }

  function compareModifiedBy(a: UserInfo, b: UserInfo) {
    if (!b.lastModifiedBy && !a.lastModifiedBy) {
      return 0;
    }
    if (!b.lastModifiedBy) {
      return 1;
    }
    if (!a.lastModifiedBy) {
      return -1;
    }
    return a.lastModifiedBy.localeCompare(b.lastModifiedBy);
  }

  function compareModifiedByDesc(a: UserInfo, b: UserInfo) {
    if (!b.lastModifiedBy && !a.lastModifiedBy) {
      return 0;
    }
    if (!b.lastModifiedBy) {
      return -1;
    }
    if (!a.lastModifiedBy) {
      return 1;
    }
    return b.lastModifiedBy.localeCompare(a.lastModifiedBy);
  }

  function compareModifiedOn(a: UserInfo, b: UserInfo) {
    if (!b.lastModifiedOn && !a.lastModifiedOn) {
      return 0;
    }
    if (!b.lastModifiedOn) {
      return 1;
    }
    if (!a.lastModifiedOn) {
      return -1;
    }
    return b.lastModifiedOn > a.lastModifiedOn ? -1 : 1;
  }

  function compareModifiedOnDesc(a: UserInfo, b: UserInfo) {
    if (!b.lastModifiedOn && !a.lastModifiedOn) {
      return 0;
    }
    if (!b.lastModifiedOn) {
      return -1;
    }
    if (!a.lastModifiedOn) {
      return 1;
    }
    return b.lastModifiedOn > a.lastModifiedOn ? 1 : -1;
  }

  const sortFunction = (list: UserInfo[]) => {
    if (list.length > 0) {
      const tempSortedUsers = [...list];
      let sortedList: UserInfo[] = [];
      if (order === "asc") {
        if (orderBy === SORT_KEY_EMAIL) {
          sortedList = tempSortedUsers.sort(compareEmailId);
        } else if (orderBy === SORT_KEY_NAME) {
          sortedList = tempSortedUsers.sort(compareFirstName);
        } else if (orderBy === SORT_KEY_MODIFIED_ON) {
          sortedList = tempSortedUsers.sort(compareModifiedOn);
        } else if (orderBy === SORT_KEY_MODIFIED_BY) {
          sortedList = tempSortedUsers.sort(compareModifiedBy);
        }
      }
      if (order === "desc") {
        if (orderBy === SORT_KEY_EMAIL) {
          sortedList = tempSortedUsers.sort(compareEmailIdDesc);
        } else if (orderBy === SORT_KEY_NAME) {
          sortedList = tempSortedUsers.sort(compareFirstNameDesc);
        } else if (orderBy === SORT_KEY_MODIFIED_ON) {
          sortedList = tempSortedUsers.sort(compareModifiedOnDesc);
        } else if (orderBy === SORT_KEY_MODIFIED_BY) {
          sortedList = tempSortedUsers.sort(compareModifiedByDesc);
        }
      }
      setUsers(sortedList);
      return sortedList;
    }
  };

  useEffect(() => {
    sortFunction(users);
  }, [order, orderBy]);

  const handleKeyPress = (e: any) => {
    if (e.key === "Enter") {
      setSearchKeyword(search);
      e.preventDefault();
    }
  };

  const handleSearchTyping = (e: any) => {
    setSearch(e.target.value);
    if (e.target.value !== "") {
      const temp = searchUsers;
      const filteredRows = temp.filter((row: UserInfo) => {
        return row.nameFirst
          .toLowerCase()
          .includes(e.target.value.toLowerCase());
      });
      setUsers(filteredRows);
    } else {
      setUsers(searchUsers);
    }
  };

  const searchClear = () => {
    setSearch("");
    setUsers(searchUsers);
  };

  const handleResetPassword = (id: string) => {
    setOpenResetPwDialog(true);
    setFocusUserId(id);
  };

  const handleCloseResetPwDialog = () => {
    setOpenResetPwDialog(false);
  };

  const resetPassword = () => {
    setIsloading(true);
    const body = {
      id: focusUserId,
    };
    Http.post({
      url: `/api/v2/users/reset-password`,
      state: userInfo,
      body,
    })
      .then((response: any) => {
        setAlertOpenResetPw(true);
        setOpenResetPwDialog(false);
        setIsloading(false);
        setFocusEmailId("");
        setFocusUserId("");
      })
      .catch((error) => {
        appLogger.error({
          errObj: {
            method: "resetPassword",
            component: "users",
            fileName: "manage.tsx",
            err: error,
          },
        });
        setIsloading(false);
        setErrorAlertOpenResetPw(true);
      });
  };

  const handleAlertCloseResetPw = () => {
    setAlertOpenResetPw(false);
  };

  const handleErrorAlertCloseResetPw = () => {
    setErrorAlertOpenResetPw(false);
  };
  const handleRole = (userDetails: any) => {
    for (const key in roleConfig) {
      if (userDetails.userRole == roleConfig[key]) {
        return key;
      }
    }
  };

  const handleClosePopup = () => {
    props.setClosePopup();
    fetchUserList();
    setEditOpen(false);
  };
  // useEffect(() => {
  //   if (
  //     userInfo &&
  //     userInfo.idToken &&
  //     userInfo.idToken.length > 0 &&
  //     productLists.length < 1
  //   ) {
  //     Http.get({
  //       url: `/api/v2/products/0`,
  //       state: userInfo,
  //     })
  //       .then((response: any) => {
  //         if (
  //           response &&
  //           response.productNameList &&
  //           response.productNameList.length > 0
  //         ) {
  //           const prods = response.productNameList;
  //           setProductResponse(response.productNameList);
  //         } else {
  //           setIsloading(false);
  //           props.snackbarShowMessage("No Product Found", "error");
  //         }
  //       })
  //       .catch((error: any) => {
  //         props.snackbarShowMessage(error.message, "error");
  //         setIsloading(false);
  //       });
  //   }
  // }, [userInfo]);
  return (
    <Box>
      <Grid className="manage-search" container spacing={2}>
        <Grid item xs={12} md={4} lg={2} sx={{ mb: 1 }}>
          <FormControl className="custom-select" fullWidth>
            <InputLabel>Search</InputLabel>
            <OutlinedInput
              type="text"
              value={search}
              onChange={handleSearchTyping}
              onKeyPress={handleKeyPress}
              id="search-input"
              endAdornment={
                <>
                  {search && (
                    <InputAdornment position="end" onClick={searchClear}>
                      <IconButton
                        aria-label="search icon"
                        edge="end"
                        className="search-fb-icon"
                      >
                        <CloseIcon className="cursor-pointer" />
                      </IconButton>
                    </InputAdornment>
                  )}
                  <InputAdornment position="end">
                    <IconButton aria-label="search icon" edge="end">
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                </>
              }
              label="Search"
            />
          </FormControl>
        </Grid>
      </Grid>
      <Box className="table-wrap">
        <Table className={isLoading ? "table loader" : "table"}>
          <TableHead>
            <TableRow>
              <TableCell>
                <TableSortLabel
                  active={orderBy === SORT_KEY_NAME}
                  direction={orderBy === SORT_KEY_NAME ? order : "asc"}
                  onClick={() => {
                    handleRequestSort(SORT_KEY_NAME);
                  }}
                  hideSortIcon={false}
                >
                  <Typography>User Name</Typography>
                  <span
                    className={
                      orderBy === SORT_KEY_NAME
                        ? `custom-sort-icon active ${order}`
                        : "custom-sort-icon"
                    }
                  >
                    <ArrowUpwardIcon />
                    <ArrowDownwardIcon />
                  </span>
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={orderBy === SORT_KEY_EMAIL}
                  direction={orderBy === SORT_KEY_EMAIL ? order : "asc"}
                  onClick={() => {
                    handleRequestSort(SORT_KEY_EMAIL);
                  }}
                  hideSortIcon={false}
                >
                  <Typography>Email</Typography>
                  <span
                    className={
                      orderBy === SORT_KEY_EMAIL
                        ? `custom-sort-icon active ${order}`
                        : "custom-sort-icon"
                    }
                  >
                    <ArrowUpwardIcon />
                    <ArrowDownwardIcon />
                  </span>
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                  active={orderBy === SORT_KEY_MODIFIED_ON}
                  direction={orderBy === SORT_KEY_MODIFIED_ON ? order : "asc"}
                  onClick={() => {
                    handleRequestSort(SORT_KEY_MODIFIED_ON);
                  }}
                  hideSortIcon={false}
                >
                  <Typography>Modified On</Typography>
                  <span
                    className={
                      orderBy === SORT_KEY_MODIFIED_ON
                        ? `custom-sort-icon active ${order}`
                        : "custom-sort-icon"
                    }
                  >
                    <ArrowUpwardIcon />
                    <ArrowDownwardIcon />
                  </span>
                </TableSortLabel>
              </TableCell>
              {/* <TableCell>
                <TableSortLabel
                  active={orderBy === SORT_KEY_MODIFIED_BY}
                  direction={orderBy === SORT_KEY_MODIFIED_BY ? order : "asc"}
                  onClick={() => {
                    handleRequestSort(SORT_KEY_MODIFIED_BY);
                  }}
                  hideSortIcon={false}
                  IconComponent={SwapVertIcon}
                >
                  <Typography style={{fontWeight: '700', color: '#000'}}>Modified By</Typography>
                </TableSortLabel>
              </TableCell> */}
              <TableCell>
                <Typography>Role</Typography>
              </TableCell>
              <TableCell>
                <Typography>Actions</Typography>
              </TableCell>
            </TableRow>
          </TableHead>

          {/* <TableBody>
          {(rowsPerPage > 0
            ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            : rows
          ).map((row) => (
            <TableRow key={row.name}>
              <TableCell>{row.name}</TableCell>
              <TableCell>{row.version}</TableCell>
              <TableCell>{row.platform}</TableCell>
            </TableRow>
          ))}
          {emptyRows > 0 && (
            <TableRow style={{ height: 53 * emptyRows }}>
              <TableCell colSpan={6} />
            </TableRow>
          )}
        </TableBody> */}

          <TableBody>
            {(rowsPerPage > 0
              ? users.slice(
                  page * rowsPerPage,
                  page * rowsPerPage + rowsPerPage
                )
              : users
            ).map((user: UserInfo, index: number) => {
              if (index < itemLimit.lowerLimit) {
                return;
              }
              if (index > itemLimit.upperLimit) {
                return;
              }
              return (
                <TableRow key={index}>
                  <TableCell>
                    {user.profilePic && (
                      <img className="prod-logo" src={user.profilePic} />
                    )}

                    {!user.profilePic && (
                      <Typography className="prod-logo-txt">
                        {user.nameFirst[0].toUpperCase()}
                      </Typography>
                    )}
                    <Typography
                      style={{ color: "#0157FF", cursor: "pointer" }}
                      onClick={() => hadleEditOpen(user)}
                    >
                      {user.nameFirst + " " + user.nameLast}
                    </Typography>
                    <Typography></Typography>
                  </TableCell>
                  <TableCell>
                    <Typography>{user.emailId}</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography>
                      {user && user.lastModifiedOn
                        ? getDateTime(user.lastModifiedOn)
                        : ""}
                    </Typography>
                  </TableCell>
                  {/* <TableCell>
                    <Typography>
                      {user && user.lastModifiedBy ? user.lastModifiedBy : ""}
                    </Typography>
                  </TableCell> */}
                  <TableCell>
                    <Typography>
                      {user && user.userRole && user.userRole.length > 0
                        ? handleRole(user)
                        : ""}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <List className="table-options" sx={{ display: "flex" }}>
                      {(userInfo &&
                        userInfo.userDetails &&
                        userInfo.userDetails.emailId === user.emailId) ||
                      user.userRole === ROLE_USER_SUPERADMIN ? (
                        <ListItem
                          disabled
                          // onClick={() => handleResetPassword(user.emailId)}
                        >
                          <ListItemText
                            primary={
                              <IconWithToolTip
                                message="Reset Password"
                                iconName="icon-lock"
                              />
                            }
                          />
                        </ListItem>
                      ) : (
                        <ListItem onClick={() => handleResetPassword(user.id)}>
                          <ListItemText
                            primary={
                              <IconWithToolTip
                                message="Reset Password"
                                iconName="icon-lock"
                              />
                            }
                          />
                        </ListItem>
                      )}
                      {(userInfo &&
                        userInfo.userDetails &&
                        userInfo.userDetails.emailId === user.emailId &&
                        user.userRole === ROLE_USER_SUPERADMIN) ||
                      user.userRole != ROLE_USER_SUPERADMIN ? (
                        <ListItem
                          // title="Edit"
                          onClick={() => hadleEditOpen(user)}
                        >
                          <ListItemText
                            primary={
                              <IconWithToolTip
                                message="Edit User"
                                iconName="icon-edit"
                              />
                            }
                          />
                        </ListItem>
                      ) : (
                        <ListItem
                          // title="Edit"
                          disabled
                          onClick={() => hadleEditOpen(user)}
                        >
                          <ListItemText
                            primary={
                              <IconWithToolTip
                                message="Edit User"
                                iconName="icon-edit"
                              />
                            }
                          />
                        </ListItem>
                      )}

                      {(userInfo &&
                        userInfo.userDetails &&
                        userInfo.userDetails.emailId === user.emailId) ||
                      user.userRole === ROLE_USER_SUPERADMIN ? (
                        <ListItem
                          // title="Delete"
                          disabled
                          // onClick={() => handleDeleteOpen(user)}
                        >
                          <ListItemText
                            primary={
                              <IconWithToolTip
                                message="Delete User"
                                iconName="icon-delete"
                              />
                            }
                          />
                        </ListItem>
                      ) : (
                        <ListItem
                          // title="Delete"
                          onClick={() => handleDeleteOpen(user)}
                        >
                          <ListItemText
                            primary={
                              <IconWithToolTip
                                message="Delete User"
                                iconName="icon-delete"
                              />
                            }
                          />
                        </ListItem>
                      )}
                    </List>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
          <TableFooter>
            <TableRow></TableRow>
          </TableFooter>
        </Table>
        <TablePagination
          component="div"
          rowsPerPageOptions={[10, 15, 20]}
          count={users.length}
          rowsPerPage={rowsPerPage}
          page={page}
          SelectProps={{
            inputProps: {
              "aria-label": "rows per page",
            },
            native: true,
          }}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          ActionsComponent={TablePaginationActions}
        />
      </Box>

      {deleteOpen && (
        <DeleteDialog
          deletepopupShow={deleteOpen}
          deletepopupClose={handleDeleteClose}
          handleDeleteConfirm={deleteUser}
          type="user"
        />
      )}

      <Dialog
        className="form-container text-center"
        onClose={handleCloseResetPwDialog}
        open={openResetPwDialog}
      >
        <Box
          className={isLoading ? "form-wrap loader" : "form-wrap"}
          style={{ paddingLeft: "24px", paddingRight: "24px" }}
        >
          <DialogTitle>Reset Password</DialogTitle>
          <Typography className="info">
            Do you really want to reset password for {focusEmailId}?
          </Typography>
          <Box style={{ paddingBottom: "16px", paddingTop: "16px" }}>
            <Button variant="contained" onClick={resetPassword}>
              reset
            </Button>
            <Button
              variant="text"
              onClick={handleCloseResetPwDialog}
              style={{ marginLeft: "10px" }}
            >
              cancel
            </Button>
          </Box>
        </Box>
      </Dialog>

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={alertOpen}
        autoHideDuration={2000}
        onClose={handleAlertClose}
      >
        <Alert onClose={handleAlertClose} severity="success">
          user deleted successfully !!!
        </Alert>
      </Snackbar>

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={errorAlertOpen}
        autoHideDuration={2000}
        onClose={handleErrorAlertClose}
      >
        <Alert onClose={handleErrorAlertClose} severity="error">
          Error in user delete !!!
        </Alert>
      </Snackbar>

      <UserForm
        editOpen={editOpen}
        editID={editID}
        addOpen={props.addOpen}
        setEditPopup={hadleEditPopup}
        setClosePopup={handleClosePopup}
        productLists={productLists}
      />

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={alertOpenResetPw}
        autoHideDuration={2000}
        onClose={handleAlertCloseResetPw}
      >
        <Alert onClose={handleAlertCloseResetPw} severity="success">
          Password reset successfully !!!
        </Alert>
      </Snackbar>

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={errorAlertOpenResetPw}
        autoHideDuration={2000}
        onClose={handleErrorAlertCloseResetPw}
      >
        <Alert onClose={handleErrorAlertCloseResetPw} severity="error">
          Error in password reset !!!
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default Manage;
